import React from 'react';

const C = {
  green:      '#1A9E78',
  greenMid:   '#0F6E56',
  greenLight: '#E8F5F0',
  purple:     '#534AB7',
  purpleLight:'#EEEDFE',
  ink:        '#1A1A2E',
  terra:      '#C4784A',
  terraLight: '#FDF0E6',
  surface:    '#F9FAFB',
};

// Logo SVG fideele a la charte : "haven" en blanc italique + "ly" en vert
const LOGO_DARK  = 'data:image/svg+xml;base64,' + btoa('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 60" width="160" height="32"><text x="2" y="46" font-family="Georgia,serif" font-size="48" font-style="italic" font-weight="700" fill="#1A1A2E">haven</text><text x="178" y="46" font-family="Georgia,serif" font-size="48" font-style="italic" font-weight="700" fill="#1A9E78">ly</text></svg>');

const BASE_CSS = `
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family:'Helvetica Neue',Helvetica,Arial,sans-serif; color:#1A1A2E; background:#fff; }
  @media print {
    @page { margin:0; size:A4; }
    body { -webkit-print-color-adjust:exact; print-color-adjust:exact; }
    .no-print { display:none !important; }
  }
  .page { width:210mm; min-height:297mm; margin:0 auto; display:flex; flex-direction:column; }
  .header { display:flex; justify-content:space-between; align-items:center; padding:22px 32px 20px; }
  .logo img { height:42px; display:block; }
  .tagline { font-size:8.5px; letter-spacing:0.4px; margin-top:3px; }
  .header-right { text-align:right; }
  .doc-type { font-size:9px; font-weight:700; letter-spacing:2px; text-transform:uppercase; opacity:0.7; }
  .doc-name { font-size:13px; font-weight:600; color:#fff; margin-top:5px; }
  .doc-date { font-size:9px; opacity:0.5; margin-top:3px; }
  .body { padding:28px 32px; flex:1; }
  .info-bar { display:grid; grid-template-columns:repeat(4,1fr); border:1px solid #E5E7EB; border-radius:12px; overflow:hidden; margin-bottom:22px; }
  .info-block { padding:14px 10px; text-align:center; border-right:1px solid #E5E7EB; }
  .info-block:last-child { border-right:none; }
  .info-val { font-size:15px; font-weight:700; }
  .info-lbl { font-size:9px; color:#9CA3AF; margin-top:3px; text-transform:uppercase; letter-spacing:0.5px; }
  .toggles { display:grid; grid-template-columns:repeat(3,1fr); gap:10px; margin-bottom:24px; }
  .toggle { padding:12px 14px; border-radius:10px; display:flex; align-items:center; gap:10px; }
  .toggle-emoji { font-size:20px; }
  .toggle-lbl { font-size:11px; font-weight:700; }
  .toggle-val { font-size:10px; margin-top:1px; opacity:0.85; }
  .sec-title { font-size:9.5px; font-weight:700; letter-spacing:1.5px; text-transform:uppercase; color:#1A9E78; border-left:3px solid #1A9E78; padding:2px 0 2px 10px; margin:18px 0 8px; }
  .rules-p { font-size:11px; line-height:1.85; color:#374151; margin-bottom:3px; }
  .guide-sec { margin-bottom:18px; }
  .guide-hd { padding:10px 14px; border-radius:8px; margin-bottom:8px; display:flex; align-items:center; gap:8px; }
  .guide-emoji { font-size:16px; }
  .guide-title { font-size:12px; font-weight:700; }
  .guide-item { font-size:11px; color:#374151; line-height:1.75; padding-left:16px; position:relative; margin-bottom:3px; }
  .guide-item::before { content:"–"; position:absolute; left:4px; color:#9CA3AF; }
  .contact-box { background:#E8F5F0; border-left:4px solid #1A9E78; border-radius:10px; padding:16px 20px; margin-top:28px; }
  .contact-title { font-size:12px; font-weight:700; color:#0F6E56; margin-bottom:5px; }
  .contact-txt { font-size:10px; color:#374151; line-height:1.7; }
  .footer { padding:12px 32px; background:#F9FAFB; border-top:1px solid #E5E7EB; display:flex; justify-content:space-between; align-items:center; margin-top:auto; }
  .footer img { height:18px; opacity:0.25; }
  .footer-txt { font-size:8.5px; color:#9CA3AF; }
  .print-btn { position:fixed; bottom:28px; right:28px; background:#1A9E78; color:#fff; border:none; padding:15px 30px; border-radius:30px; font-size:14px; font-weight:600; cursor:pointer; box-shadow:0 6px 24px rgba(26,158,120,0.4); z-index:999; display:flex; align-items:center; gap:8px; font-family:inherit; }
  .print-btn:hover { background:#0F6E56; }
`;

const PRINT_BTN = `<button class="print-btn no-print" onclick="window.print()">
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
    <polyline points="6 9 6 2 18 2 18 9"/>
    <path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/>
    <rect x="6" y="14" width="12" height="8"/>
  </svg>
  Imprimer / Enregistrer en PDF
</button>`;

function openPrintWindow(htmlContent, title) {
  const win = window.open('', '_blank');
  win.document.write(`<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8"/><title>${title}</title><style>${BASE_CSS}</style></head><body>${htmlContent}${PRINT_BTN}</body></html>`);
  win.document.close();
}

function generateReglementHTML(listing) {
  const toggles = [
    { emoji: '🚬', label: 'Fumeur',  val: listing.smoking_allowed,  yes: 'Autorisé',   no: 'Interdit'    },
    { emoji: '🐾', label: 'Animaux', val: listing.pets_allowed,     yes: 'Acceptés',   no: 'Non acceptés' },
    { emoji: '🎉', label: 'Fêtes',   val: listing.parties_allowed,  yes: 'Autorisées', no: 'Interdites'  },
  ];

  const togglesHTML = toggles.map(t => `
    <div class="toggle" style="background:${t.val ? '#E8F5F0' : '#FEF2F2'}">
      <span class="toggle-emoji">${t.emoji}</span>
      <div>
        <div class="toggle-lbl" style="color:${t.val ? '#0F6E56' : '#B91C1C'}">${t.label}</div>
        <div class="toggle-val" style="color:${t.val ? '#0F6E56' : '#B91C1C'}">${t.val ? '✓ ' + t.yes : '✗ ' + t.no}</div>
      </div>
    </div>`).join('');

  let rulesHTML = '';
  for (const line of (listing.rules || '').split('\n')) {
    const t = line.trim();
    if (!t) { rulesHTML += '<div style="height:5px"></div>'; continue; }
    const isTitle = (t === t.toUpperCase() && t.length > 3) || (t.endsWith(':') && t.length < 60) || t.startsWith('##') || t.startsWith('**');
    if (isTitle) {
      rulesHTML += `<div class="sec-title">${t.replace(/\*\*|##|#/g,'').replace(/:$/,'').trim()}</div>`;
    } else {
      rulesHTML += `<p class="rules-p">${t}</p>`;
    }
  }

  return `<div class="page">
  <div class="header" style="background:#fff; border-bottom:2px solid #E5E7EB; padding:20px 32px;">
    <div class="logo">
      <img src="${LOGO_DARK}" alt="havenly" style="height:38px"/>
      <div class="tagline" style="color:#9CA3AF; margin-top:3px;">Plateforme Française de location saisonnière</div>
    </div>
    <div class="header-right">
      <div class="doc-type" style="color:#9CA3AF;">Règlement intérieur</div>
      <div class="doc-name" style="color:#1A1A2E; font-size:14px; font-weight:700; margin-top:4px;">${(listing.title || 'Votre logement').slice(0,48)}${listing.city ? ' · ' + listing.city : ''}</div>
      <div class="doc-date" style="color:#9CA3AF;">Généré le ${new Date().toLocaleDateString('fr-FR')}</div>
    </div>
  </div>

  <div style="background:#FDF0E6; border-bottom:1px solid #F0C9A0; padding:14px 32px;">
    <p style="font-size:12px; color:#8B4513; line-height:1.7; margin:0;">
      🏡 <strong>Bienvenue chez nous !</strong> Pour que votre séjour se passe dans les meilleures conditions, nous vous remercions de lire attentivement ce règlement. Nous avons tout préparé avec soin pour vous accueillir comme il se doit. 🌟
    </p>
  </div>

  <div class="body">
    <div class="info-bar">
      <div class="info-block"><div class="info-val" style="color:#1A9E78">${listing.checkin_time || '15:00'}</div><div class="info-lbl">Check-in</div></div>
      <div class="info-block"><div class="info-val" style="color:#1A9E78">${listing.checkout_time || '11:00'}</div><div class="info-lbl">Check-out</div></div>
      <div class="info-block"><div class="info-val" style="color:#534AB7">${listing.min_nights || 1} nuit${(listing.min_nights||1)>1?'s':''}</div><div class="info-lbl">Séjour min.</div></div>
      <div class="info-block"><div class="info-val" style="color:#1A1A2E">${listing.guests_max || '—'}</div><div class="info-lbl">Voyageurs max</div></div>
    </div>
    <div class="toggles">${togglesHTML}</div>
    ${rulesHTML || '<p class="rules-p" style="color:#9CA3AF;font-style:italic">Aucun règlement renseigné.</p>'}
  </div>
  <div class="footer">
    <img src="${LOGO_DARK}" alt="havenly"/>
    <div class="footer-txt">havenly.fr · contact@havenly.fr · Plateforme française de location saisonnière</div>
    <div class="footer-txt">Généré le ${new Date().toLocaleDateString('fr-FR')}</div>
  </div>
</div>`;
}

function generateGuideHTML(listing) {
  const guide = listing.local_guide || listing.localGuide || {};
  const sections = [
    { key:'restaurants', emoji:'🍽', label:'Restaurants & Cafés',     color:'#C4784A', bg:'#FDF0E6' },
    { key:'plages',      emoji:'🏖', label:'Plages & Nature',          color:'#1A9E78', bg:'#E8F5F0' },
    { key:'activites',   emoji:'🎯', label:'Activités & Visites',      color:'#534AB7', bg:'#EEEDFE' },
    { key:'transports',  emoji:'🚌', label:'Transports & Bons plans',  color:'#1A1A2E', bg:'#F3F4F6' },
  ];

  const sectionsHTML = sections.map(s => {
    const content = (guide[s.key] || '').trim();
    if (!content) return '';
    const items = content.split(/\.\s+|\n/).filter(i => i.trim().length > 2);
    return `<div class="guide-sec">
      <div class="guide-hd" style="background:${s.bg}">
        <span class="guide-emoji">${s.emoji}</span>
        <span class="guide-title" style="color:${s.color}">${s.label}</span>
      </div>
      ${items.map(i => `<div class="guide-item">${i.trim().replace(/\.$/,'')}</div>`).join('')}
    </div>`;
  }).join('');

  return `<div class="page">
  <div class="header" style="background:#fff; border-bottom: 2px solid #E5E7EB; padding: 20px 32px;">
    <div class="logo">
      <img src="${LOGO_DARK}" alt="havenly" style="height:38px"/>
      <div class="tagline" style="color:#9CA3AF; margin-top:3px;">Plateforme Française de location saisonnière</div>
    </div>
    <div class="header-right">
      <div class="doc-type" style="color:#9CA3AF;">Guide local</div>
      <div class="doc-name" style="color:#1A1A2E; font-size:14px; font-weight:700; margin-top:4px;">${listing.city || 'Votre destination'}</div>
      <div class="doc-date" style="color:#9CA3AF;">${(listing.title || '').slice(0,42)}</div>
    </div>
  </div>

  <div style="background:#E8F5F0; border-bottom:1px solid #C6E8DC; padding:14px 32px;">
    <p style="font-size:12px; color:#0F6E56; line-height:1.7; margin:0;">
      🌿 <strong>Bienvenue !</strong> Nous avons sélectionné pour vous nos meilleures adresses locales — restaurants, plages, activités et bons plans — pour que votre séjour à <strong>${listing.city || 'destination'}</strong> soit inoubliable. Profitez bien ! 🏖
    </p>
  </div>

  <div class="body">
    <div class="info-bar" style="margin-bottom:24px">
      <div class="info-block"><div class="info-val" style="color:#1A9E78">${listing.checkin_time||'15:00'}</div><div class="info-lbl">Check-in</div></div>
      <div class="info-block"><div class="info-val" style="color:#1A9E78">${listing.checkout_time||'11:00'}</div><div class="info-lbl">Check-out</div></div>
      <div class="info-block"><div class="info-val" style="color:#1A9E78">${listing.guests_max||'—'}</div><div class="info-lbl">Voyageurs max</div></div>
      <div class="info-block"><div class="info-val" style="color:#1A9E78">${listing.min_nights||1}n</div><div class="info-lbl">Séjour min.</div></div>
    </div>
    ${sectionsHTML || '<p style="color:#9CA3AF;font-style:italic;font-size:12px">Aucun guide local renseigné.</p>'}
    <div class="contact-box">
      <div class="contact-title">Une question pendant votre séjour ?</div>
      <div class="contact-txt">Contactez votre hôte directement via la messagerie Havenly.<br/>En cas de litige ou urgence : <strong>contact@havenly.fr</strong> · Médiation sous 72h garantie.</div>
    </div>
  </div>

  <div class="footer">
    <img src="${LOGO_DARK}" alt="havenly"/>
    <div class="footer-txt">havenly.fr · contact@havenly.fr · Plateforme française de location saisonnière</div>
    <div class="footer-txt">Généré le ${new Date().toLocaleDateString('fr-FR')}</div>
  </div>
</div>`;
}

export default function ListingDocuments({ listing }) {
  const hasRules = !!(listing?.rules?.trim());
  // Le guide peut etre stocke sous 'local_guide' (Supabase) ou 'localGuide' (state React)
  const guideData = listing?.local_guide || listing?.localGuide || {};
  const hasGuide = !!(guideData && typeof guideData === 'object' && Object.values(guideData).some(v => v && String(v).trim().length > 0));
  const isMobile = window.innerWidth < 600;

  return (
    <div style={{ background:'var(--white)', border:'1px solid var(--border)', borderRadius:16, padding: isMobile ? '16px' : '20px 24px' }}>
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:6 }}>
        <div style={{ width:32, height:32, borderRadius:8, background:C.greenLight, flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center' }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={C.greenMid} strokeWidth="2">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
        </div>
        <div>
          <div style={{ fontSize:14, fontWeight:600, color:'var(--ink)' }}>Documents du logement</div>
          <div style={{ fontSize:11, color:'var(--ink-3)', lineHeight:1.4 }}>S'ouvre dans un nouvel onglet · Imprimez ou enregistrez en PDF</div>
        </div>
      </div>

      <div style={{ height:1, background:'var(--border)', margin:'14px 0' }} />

      <div style={{ display:'flex', flexDirection: isMobile ? 'column' : 'row', gap:12 }}>
        {/* Règlement */}
        <div style={{ flex:1, border:`1px solid ${hasRules ? C.green : 'var(--border)'}`, borderRadius:12, padding:16, background:hasRules ? C.greenLight : C.surface, display:'flex', flexDirection: isMobile ? 'row' : 'column', alignItems: isMobile ? 'center' : 'stretch', gap:12 }}>
          <div style={{ fontSize: isMobile ? 28 : 24, flexShrink:0 }}>📋</div>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13, fontWeight:600, color:'var(--ink)', marginBottom:3 }}>Règlement intérieur</div>
            <div style={{ fontSize:11, color:'var(--ink-3)', lineHeight:1.5 }}>
              {hasRules ? 'Horaires, conditions et règles de la maison.' : "Ajoutez un règlement pour activer l'export."}
            </div>
          </div>
          <button onClick={() => openPrintWindow(generateReglementHTML(listing), 'Reglement - ' + (listing.title||'logement'))}
            disabled={!hasRules}
            style={{ padding: isMobile ? '10px 16px' : '10px 0', borderRadius:10, border:'none', cursor:hasRules?'pointer':'not-allowed', background:hasRules?C.green:'var(--border)', color:hasRules?'#fff':'var(--ink-4)', fontSize:13, fontWeight:600, fontFamily:'var(--sans)', display:'flex', alignItems:'center', justifyContent:'center', gap:6, whiteSpace:'nowrap', flexShrink:0 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
            Ouvrir le PDF
          </button>
        </div>

        {/* Guide local */}
        <div style={{ flex:1, border:`1px solid ${hasGuide ? C.purple : 'var(--border)'}`, borderRadius:12, padding:16, background:hasGuide ? C.purpleLight : C.surface, display:'flex', flexDirection: isMobile ? 'row' : 'column', alignItems: isMobile ? 'center' : 'stretch', gap:12 }}>
          <div style={{ fontSize: isMobile ? 28 : 24, flexShrink:0 }}>🗺</div>
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13, fontWeight:600, color:'var(--ink)', marginBottom:3 }}>Guide local</div>
            <div style={{ fontSize:11, color:'var(--ink-3)', lineHeight:1.5 }}>
              {hasGuide ? 'Restaurants, plages, activités et transports.' : "Renseignez le guide local pour activer l'export."}
            </div>
          </div>
          <button onClick={() => openPrintWindow(generateGuideHTML(listing), 'Guide local - ' + (listing.city||'logement'))}
            disabled={!hasGuide}
            style={{ padding: isMobile ? '10px 16px' : '10px 0', borderRadius:10, border:'none', cursor:hasGuide?'pointer':'not-allowed', background:hasGuide?C.purple:'var(--border)', color:hasGuide?'#fff':'var(--ink-4)', fontSize:13, fontWeight:600, fontFamily:'var(--sans)', display:'flex', alignItems:'center', justifyContent:'center', gap:6, whiteSpace:'nowrap', flexShrink:0 }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
            Ouvrir le PDF
          </button>
        </div>
      </div>

      <div style={{ marginTop:14, fontSize:11, color:'var(--ink-4)', textAlign:'center' }}>
        Dans l'onglet qui s'ouvre · Cliquez "Imprimer" puis choisissez "Enregistrer en PDF"
      </div>
    </div>
  );
}
